import {useState} from "react";
import {GeolocationPermissionDeniedModal} from "./components/GeolocationPermissionDeniedModal";
import {GeolocationContext} from "./context/GeolocationContext";

export type GeolocationProviderProps = {
    children: React.ReactNode;
};

export function GeolocationProvider({children}: GeolocationProviderProps) {
    const [isGeolocationPermissionDeniedModalOpen, setIsGeolocationPermissionDeniedModalOpen] =
        useState(false);

    return (
        <GeolocationContext.Provider
            value={{
                showGeolocationPermissionDeniedModal: () =>
                    setIsGeolocationPermissionDeniedModalOpen(true),
            }}
        >
            {children}
            <GeolocationPermissionDeniedModal
                show={isGeolocationPermissionDeniedModalOpen}
                onHide={() => setIsGeolocationPermissionDeniedModalOpen(false)}
            />
        </GeolocationContext.Provider>
    );
}
